var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { SuggestAction, SuggestObjectAction } from '@yandex-taxi/js-integration-api';
import { isGeoObject, isPart, isPoint, toPoint } from '../../../utils';
export var getSuggest = function (idx, state) { return state.suggest[idx]; };
var VALID_ACTION = [SuggestAction.FINALIZE, SuggestAction.PIN_DROP];
export var isAddressValid = function (body) { return VALID_ACTION.includes(body.action); };
export var toSuggestBody = function (type, value, previousPoint, isZero) {
    // state: {
    //   location: [lon, lat],
    // }
    // точка относительно которой будет посчитана дистанция
    // для точки А это координаты, с которыми инициализировали приложение
    // для точки Б это координаты точки А, и так далее
    var partialBody = {
        type: type,
        state: {
            accuracy: 0,
            location: previousPoint,
        },
    };
    if (isPart(value)) {
        return __assign(__assign({}, partialBody), { action: SuggestAction.USER_INPUT, part: value });
    }
    if (isPoint(value)) {
        return __assign(__assign({}, partialBody), { action: isZero ? SuggestAction.ZERO_SUGGEST : SuggestAction.PIN_DROP, position: value, sticky: false });
    }
    if (isGeoObject(value)) {
        // решение, перезапрашивать адрес для уточнения или нет принимает приложение-потребитель
        // заказ можно совершить и с не финализированным адресом
        // к примеру турбоапп просто не показывает такие адреса в саджесте,
        // тем самым исключая возможность попадания в такую ситуацию
        if (value.action === SuggestObjectAction.SUBSTITUTE) {
            return __assign(__assign({}, partialBody), { action: SuggestAction.USER_SELECT, prev_log: value.log, part: value.text });
        }
        return __assign(__assign({}, partialBody), { action: SuggestAction.FINALIZE, prev_log: value.log, position: toPoint(value.pos), sticky: true });
    }
    throw new Error('todo: unknown address value');
};
export var getAddressType = function (index, length) {
    switch (index) {
        case 0: {
            return 'a';
        }
        case length - 1: {
            return 'b';
        }
        default: {
            return "mid" + index;
        }
    }
};
